export default __webpack_public_path__ + "static/media/family.8915465c.jpg";